import api from './api';

// Selling prices (Revenue), scoped to a budget version. Backed by
// /api/selling-prices (sellingPriceController.js).
//
// A row with customer_group_code = null is the universal COUNTRY RETAIL PRICE;
// a row with a customer_group_code OVERRIDES the country retail price for
// customers in that group.
export const sellingPriceService = {
  // Paging is OPT-IN — see customerService.getCustomers.
  getSellingPrices: async (versionId, { filters, limit, offset } = {}) => {
    const response = await api.get(`/selling-prices/${versionId}`, {
      params: {
        ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
        ...(limit ? { limit } : {}),
        ...(offset ? { offset } : {}),
      },
    });
    return response.data;
  },
  upsertSellingPrices: async (payload) => {
    // payload: { version_id, mode: 'overwrite'|'replace', rows: [...] }
    const response = await api.post('/selling-prices', payload);
    return response.data;
  },
};

export default sellingPriceService;
